export async function applyDropdownSelection (model, button, fallbackColor) {
  if (model.onClick) {
    await model.onClick(button.id)
  }

  model.value = button
  model.color = button.color || fallbackColor
}
